import { FormikProvider } from 'formik';
import PageContainer from '@/sections/container';
import { MainContainer } from '@/apps/core';
import { useAccountSettings } from '@/hooks/account.settings.hooks';
import { UserSelfAccount, UserPasswordManagement } from '@/apps/account-settings';

const AccountSettings = () => {
  const {
    accountSettingFormik,
    editMode,
    setEditMode,
    passwordValue,
    setPasswordValue,
    values,
    setShowPassMngt,
    showPassMngt,
    loggedUser,
    errors,
    valid,
    handleSubmit,
    handleResetPassword,
    resetLinkSend
  } = useAccountSettings();

  return (
    <PageContainer>
      <MainContainer headerTitle="Users Information">
        <FormikProvider value={accountSettingFormik}>
          <UserSelfAccount
            {...{
              editMode,
              setEditMode,
              showPassMngt,
              loggedUser,
              values,
              errors,
              valid,
              handleSubmit,
              accountSettingFormik
            }}
          />
          <UserPasswordManagement {...{
            editMode,
            setEditMode,
            passwordValue,
            setPasswordValue,
            values,
            setShowPassMngt,
            showPassMngt,
            loggedUser,
            errors,
            accountSettingFormik,
            handleResetPassword,
            resetLinkSend
          }} />
        </FormikProvider>
      </MainContainer>
    </PageContainer>
  );
};

export default AccountSettings;
